import { Box, Grid, Heading, Text } from "@chakra-ui/react";
import { Figure, Reveal, SectionHead } from "@/components";
import { COST_CHART, COST_FIGURE_LEGEND, COST_HEAD, COST_TIERS, OPPORTUNITY_WINDOW, ROUTE_DIAGRAM } from "@/content";
import { CostChart } from "./figures/CostChart";
import { OpportunityWindow } from "./figures/OpportunityWindow";
import { RouteDiagram } from "./figures/RouteDiagram";

const TierHead = ({ tier }: { tier: (typeof COST_TIERS)[number] }) => (
  <Grid gap="12px" alignContent="start">
    <Text variant="eyebrow">{tier.rank}</Text>
    <Heading as="h3" variant="card" fontSize="clamp(1.5rem, 2.4vw, 2.25rem)" lineHeight={0.95} mt="-2px">
      {tier.title}
    </Heading>
    <Text fontSize="small" lineHeight={1.45} color="warm.600" maxW="46ch" sx={{ textWrap: "pretty" }}>
      {tier.lede}
    </Text>
  </Grid>
);

const Tier = ({
  tier,
  isLast = false,
  children,
}: {
  tier: (typeof COST_TIERS)[number];
  isLast?: boolean;
  children: React.ReactNode;
}) => (
  <Reveal
    className="reveal print-avoid-break"
    display="grid"
    gap="clamp(28px, 3.6vw, 48px)"
    py="clamp(36px, 4.5vw, 64px)"
    borderTop="1px solid"
    borderBottom={isLast ? "1px solid" : undefined}
    borderColor="line.hairline"
    gridTemplateColumns={{ base: "1fr", xl: "minmax(0, 0.8fr) minmax(0, 1.2fr)" }}
    alignItems="start"
  >
    <TierHead tier={tier} />
    {children}
  </Reveal>
);

export const Cost = () => (
  <Box as="section" id="cost" maxW="maxw" mx="auto" px="pad" pt="sec">
    <SectionHead head={COST_HEAD} layout="center" />

    <Tier tier={COST_TIERS[0]}>
      <Figure caption={COST_CHART.caption} note={COST_CHART.note} legend={COST_FIGURE_LEGEND}>
        <CostChart />
      </Figure>
    </Tier>

    <Tier tier={COST_TIERS[1]}>
      <Figure caption={ROUTE_DIAGRAM.caption} note={ROUTE_DIAGRAM.note}>
        <RouteDiagram />
      </Figure>
    </Tier>

    <Tier tier={COST_TIERS[2]} isLast>
      <Figure caption={OPPORTUNITY_WINDOW.caption} note={OPPORTUNITY_WINDOW.note}>
        <OpportunityWindow />
      </Figure>
    </Tier>
  </Box>
);
